import { useMemo } from 'react'
import useQueryParams from 'hooks/useQueryParams'

export default function useCruisePriceByNight() {
  const queryParams = useQueryParams()
  return useMemo(() => {
    return queryParams.get('priceBy') === 'night'
  }, [queryParams])
}
